module.exports = __webpack_public_path__ + "img/b_rimg1.82855db4.png";